// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel___GrUmh","arrow":"arrow___3Ii3q"};